import type { ISchema } from "~/models/IUserEntry";

export function useAddLocalSchemasForFieldOfLaw(
  entries: MaybeRefOrGetter<Array<ISchema> | undefined>,
  fieldOfLawId: MaybeRefOrGetter<number | undefined>
) {
  const localEntries = useLocalEntries();

  const amended = computed(() => {
    const cpy = [...(toValue(entries) ?? [])];
    const folEntries = localEntries.value
      .filter(
        (localEntry) =>
          localEntry.data.type === "schema" &&
          localEntry.data.legal_text_paragraph.field_of_law_primary_id &&
          localEntry.data.legal_text_paragraph.field_of_law_primary_id ===
            toValue(fieldOfLawId)
      )
      .map((localEntry) => localEntry.data as ISchema);
    cpy.push(...folEntries);

    return cpy;
  });

  return { amended };
}
